import { Injectable } from '@angular/core';
import * as global from '../includes/global';
import * as moment from 'moment';
import { KeyValue } from '@angular/common';
import { BehaviorSubject, Subject } from 'rxjs';
import { NgModel } from '@angular/forms';

interface TimeZone {
    text: string;
    value: string;
}
@Injectable({
    providedIn: 'root'
})
export class CommonService {
    private companySelected = new BehaviorSubject(null);
    public castCompany = this.companySelected.asObservable();

    private selectedCompany = new BehaviorSubject(null);
    public castSelectedCompany = this.selectedCompany.asObservable();

    private facilitySelected = new BehaviorSubject(null);
    public castFacility = this.facilitySelected.asObservable();

    private draftedCharge = new BehaviorSubject(null);
    public castDraftedCharge = this.draftedCharge.asObservable();

    private savedICD = new BehaviorSubject(null);
    public castSavedICD = this.savedICD.asObservable();

    private savedCPT = new BehaviorSubject(null);
    public castSavedCPT = this.savedCPT.asObservable();

    public updatedUsername = new Subject();
    public castUpdatedUsername = this.updatedUsername.asObservable();

    private selectedUserType = new BehaviorSubject(null);
    public castselectedUserType = this.selectedUserType.asObservable();

    private selectedNotesData = new BehaviorSubject(null);
    public  castSelectedNotesData = this.selectedNotesData.asObservable();

    private pageReloadRequestKey = 'page-reload-requested';
    formattedTimezones: TimeZone[] = [];

    constructor() {
        this.formattedTimezones = moment.tz.names().map(zone => {
            const offset = moment.tz(zone).utcOffset() / 60;
            const offsetSign = offset >= 0 ? '+' : '';
            const formattedOffset = `${offsetSign}${offset}:00`;
            return {
                text: `(UTC${formattedOffset}) ${zone}`,
                value: zone
            };
        });
    }

    setSelectedNotesData(notesData){
        this.selectedNotesData.next(notesData)
    }

    setSeletedUserType(user_type) {
        this.selectedUserType.next(user_type);
        console.log('user_type', user_type);
    }

    setUpdatedUsername(updatedUser) {
        this.updatedUsername.next(updatedUser);
    }
    getUserProfilePic() {
        return this.updatedUsername ? this.updatedUsername : 'https://www.w3schools.com/howto/img_avatar.png';
    }

    setDraftedCharge(charge) {

        this.draftedCharge.next(charge);
    }
    setSavedICD(charge) {

        this.savedICD.next(charge);
    }
    setSavedCPT(charge) {
        this.savedCPT.next(charge);

    }


    setCompanySelected(company) {
        this.companySelected.next(company);

    }

    setSelectedCompany(company) {
        this.selectedCompany.next(company);

    }

    setFacilitySelected(folderId) {
        this.facilitySelected.next(folderId);

    }

    currentDate() {
        return moment.utc().toDate();
    }

    attachTimeToDate(date, dateTime?) {

        const dateStr = moment(date).format('YYYY-MM-DD');
        const timeStr = (dateTime ? moment(dateTime) : moment()).format('HH:mm');

        let newDate = moment(dateStr);
        const time = moment(timeStr, 'HH:mm');

        newDate.set({
            hour: time.get('hour'),
            minute: time.get('minute'),
            second: time.get('second')
        });
        return newDate.toDate();
    }
    cleanTranscriptionTitle(str) {
        let result = str;
        const pattern = /^(\d+)_(.*)/;
        const regexExec = pattern.exec(str);

        if (regexExec && regexExec.length > 1 && regexExec[2].length) {
            result = regexExec[2];
        }
        return result.replace(/_/g, ' ');
    }

    getUserFullName(user) {
        return user ? user.first_name + ' ' + user.last_name : '';
    }

    getPatientFullName(patient) {
        let patientName = patient.first_name;
        if (patient.middle_name) {
            patientName += ' ' + patient.middle_name;
        }
        patientName += ' ' + patient.last_name;
        return patientName;
    }

    getPatientFullNameFormat2(patient) {
        let patientName = patient.last_name + ', ';
        patientName += patient.first_name;
        if (patient.middle_name && patient.middle_name.length) {
            patientName += ' ' + patient.middle_name[0].toUpperCase() + '.';
        }
        return patientName;
        // if (patientName.length > 15)
        //     { 
        //         let patientTitle = '';
        //         patientTitle = patientName.substr(0,15);
        //         return patientTitle+'...'
        //     } 
        //     else { 
        //         return patientName;
        //     } 
    }

    getFacilityTitle(facility) {
        return facility ? facility.title : '';
    }

    dateRangeToString(d1: moment.Moment, d2: moment.Moment) {
        const dateFormat = 'MMM DD, YYYY';
        if (d1 && d2 && d1.isValid() && d2.isValid()) {
            const formatD1 = d1.format(dateFormat);
            const formatD2 = d2.format(dateFormat);
            return formatD1 == formatD2 ? formatD1 : `${formatD1} - ${formatD2}`;
        }
    }

    flattenObjectToArray(ob: Object): Array<any> {
        let arr: Array<any> = [];
        Object.keys(ob).forEach(function (key) {
            arr = [...arr, ...ob[key]];
        });
        return arr;
    };

    keyDescOrder = (a: KeyValue<string, any>, b: KeyValue<string, any>): number => {
        let valueA: any = a.key;
        let valueB: any = b.key;
        const momentA = moment(new Date(valueA));
        const momentB = moment(new Date(valueB));
        if (momentA.isValid() && momentB.isValid()) {
            valueA = momentA.toDate().getTime();
            valueB = momentB.toDate().getTime();
            return valueB - valueA;
        }
        return valueA > valueB ? -1 : (valueB > valueA ? 1 : 0);
    };
    keyAscOrder = (a: KeyValue<string, any>, b: KeyValue<string, any>): number => {
        let valueA: any = a.key;
        let valueB: any = b.key;
        const momentA = moment(new Date(valueA));
        const momentB = moment(new Date(valueB));
        if (momentA.isValid() && momentB.isValid()) {
            valueA = momentA.toDate().getTime();
            valueB = momentB.toDate().getTime();
            return valueA - valueB;
        }
        return valueA > valueB ? 1 : (valueB > valueA ? -1 : 0);
    };

    showCount(count: number, max: number = 99) {
        return (count > max) ? `${max}+` : count;
    }
    toTitleCase(str) {
        str = str || '';
        return str.replace(
            /\w\S*/g,
            function (txt) {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            }
        );
    }

    dateObjToString_calenderFormat(date_obj) {

        let { year, month, day, hour = 12, minute = 0 } = date_obj;
        if (month < 10) {
            month = '0' + month;
        }
        if (day < 10) {
            day = '0' + day;
        }
        if (hour < 10) {
            hour = '0' + hour;
        }
        if (minute < 10) {
            minute = '0' + minute;
        }
        // let str = `${year}-${month}-${day}T${hour}:${minute}:00.000Z`;
        // let str = `${year}-${month}-${day}T01:00:00.000Z`;
        let str = `${year}-${month}-${day}T01:00`;


        
        return str;
    }

    dateObjToString_format2(date_obj, shouldAppendTime = true) {

        let { year, month, day, hour = 0, minute = 0 } = date_obj;
        if (month < 10) {
            month = '0' + month;
        }
        if (day < 10) {
            day = '0' + day;
        }
        if (hour < 10) {
            hour = '0' + hour;
        }
        if (minute < 10) {
            minute = '0' + minute;
        }
        let str = `${year}-${month}-${day}`;
        if (shouldAppendTime) {
            str += ` ${hour}:${minute}`;
        }
        return str;
    }

    dateObjToString(date_obj, shouldAppendTime = true) {

        let { year, month, day, hour = 0, minute = 0 } = date_obj;
        if (month < 10) {
            month = '0' + month;
        }
        if (day < 10) {
            day = '0' + day;
        }
        if (hour < 10) {
            hour = '0' + hour;
        }
        if (minute < 10) {
            minute = '0' + minute;
        }
        let str = `${month}/${day}/${year}`;
        if (shouldAppendTime) {
            str += ` ${hour}:${minute}`;
        }
        return str;
    }
    dateObjToDate(date_obj) {
        return moment({
            year: date_obj.year,
            month: date_obj.month - 1,
            day: date_obj.day,
            hour: date_obj.hour,
            minute: date_obj.minute
        }).toDate();
    }
    isValidDateObj(date_obj) {
        if (date_obj) {
            let { year, month, day, hour, minute } = date_obj;

            if ((year !== undefined) && (month !== undefined) && (day !== undefined)) {
                return true;
            }
        }
        return false;
    }
    convertDateToStringforMoment(date,shouldAppendTime = false, shouldAppendTimezone = false, isCptExpiryDate = false ) {
        const { date: days, months, years, hours, minutes, seconds } = date.toObject();
        let month = (months + 1).toString();
        let day = days.toString();
        let hr = hours.toString();
        let min = minutes.toString();
        let sec = seconds.toString();
        if (month.length === 1) {
            month = "0" + month;
        }
        if (day.length === 1) {
            day = "0" + day;
        }
        if (hr.length === 1) {
            hr = "0" + hr;
        }
        if (min.length === 1) {
            min = "0" + min;
        }
        if (sec.length === 1) {
            sec = "0" + sec;
        }
        let dateString;
        if (isCptExpiryDate)
            dateString = `${month}/${day}/${years.toString()}`;
        else
            dateString = `${years.toString()}-${month}-${day}`;
        if (shouldAppendTime) {
            dateString = `${years.toString()}-${month}-${day} ${hr}:${min}:${sec}`;
        }
        if (shouldAppendTimezone) {
            dateString = `${years.toString()}-${month}-${day} ${hr}:${min}:${sec} ${moment().format("Z")}`;
        }
        return dateString;
    }
    splitMomentToObj(momentObj): { year: number; month: number; day: number; hour: number; minute: number } {
        const { date: days, months, years, hours, minutes } = momentObj.toObject();
        const month = months + 1;
        return {
            year: years,
            month,
            day: days,
            hour: hours,
            minute: minutes
        };
    }
    
    requestPageReload() {
        const pageReloadRequested = sessionStorage.getItem( this.pageReloadRequestKey );

        if ( pageReloadRequested === 'true' ) {
            return false;
        }

        sessionStorage.setItem( this.pageReloadRequestKey, 'true' );
        window.location.reload();

        return true;
    }

    // If you are using `requestPageReload` function in component's constructor or ngOnInit,
    // then you must use `stopRequestingPageReload` function in same component's ngOnDestroy.
    stopRequestingPageReload() {
        sessionStorage.removeItem( this.pageReloadRequestKey );

        return true;
    }

    sortProviderDropdown(providers){
        providers.sort((a,b) => {
          if(a.first_name.toLowerCase() < b.first_name.toLowerCase()) { return -1; }
          if(a.first_name.toLowerCase() > b.first_name.toLowerCase()) { return 1; }
        });
      }
      
    setLocalStorageItem(componentName: string, key: string, value: any) {
        const existingObj = JSON.parse(localStorage.getItem(`dn-${componentName}`)) || {};
        existingObj[key] = value;
        localStorage.setItem(`dn-${componentName}`, JSON.stringify(existingObj));
    }
    getLocalStorageItem(componentName: string) {
        return JSON.parse(localStorage.getItem(`dn-${componentName}`)) || null;
    }
    removeLocalStorageItem(componentName: string) {
        localStorage.removeItem(`dn-${componentName}`);
    }
    validateComment(comment) {
        // Check if the comment contains special characters, including spaces
        const hasSpecialChar = /[!@#$%^&*(),.?":{}|<> \n\\\/\[\]\-~_`]/.test(comment);
      
        // Check if the comment contains alphabets or numbers
        const hasAlphabetsOrNumbers = /[a-zA-Z0-9]/.test(comment);
      
        // If the comment contains special characters (including spaces), it should also contain alphabets or numbers to be valid
        // If there are no special characters (including spaces), the comment is considered valid
        return hasSpecialChar ? hasAlphabetsOrNumbers : true;
    }

    formatDateOfBirth(value: string, dobControl: NgModel) {
        let formatted_date_of_birth = value.replace(/\D/g, '');
        if (formatted_date_of_birth.length === 0) {
            formatted_date_of_birth = '';
        } else if (formatted_date_of_birth.length <= 2) {
            formatted_date_of_birth = formatted_date_of_birth.replace(/^(\d{0,2})/, '$1');
        } else if (formatted_date_of_birth.length <= 4) {
            formatted_date_of_birth = formatted_date_of_birth.replace(/^(\d{0,2})(\d{0,2})/, '$1-$2');
        } else if (formatted_date_of_birth.length <= 8) {
            formatted_date_of_birth = formatted_date_of_birth.replace(/^(\d{0,2})(\d{0,2})(\d{0,4})/, '$1-$2-$3');
        } else {
            formatted_date_of_birth = formatted_date_of_birth.substring(0, 8);
            formatted_date_of_birth = formatted_date_of_birth.replace(/^(\d{0,2})(\d{0,2})(\d{0,4})/, '$1-$2-$3');
        }
        if (moment(formatted_date_of_birth, 'MM-DD-YYYY', true).isValid()) {
            dobControl.control.setValue(formatted_date_of_birth);
            dobControl.control.setErrors(null);
        } else {
            dobControl.control.setErrors({ invalidDate: true });
        }
    }

    getCleanedDomainName(domainName) {
        if(!domainName) {
            return '';
        }
        const regexPrefix = /^(https?:\/\/)?(www\.)?/
        // remove protocol
        domainName = domainName.replace(regexPrefix, '');
        // remove port
        domainName = domainName.split(':')[0];
        return domainName;
    }

    getFormattedTimeZones(): TimeZone[] {
        return this.formattedTimezones;
    }

}
